<template>
  <div class="notification-message-wrap">
    <v-flex 
      v-if="type === 'topline'" 
      class="notification-message"
      :class="{ active: isActive }"
      :style="{ background: background }"
      >
        <div class="message-top-line"></div>
        <div class="py-2 px-12 message-text">
          <v-icon v-if="status === 'success'" class="mr-2 message-icon">check_circle</v-icon> 
          <v-icon v-if="status === 'error'" class="mr-2 message-icon">warning</v-icon> 
          {{ text }}</div>
    </v-flex>
    <v-snackbar
      v-else
      top
      timeout="-1"
      app
      center
      min-width="320"
      v-model="isActive"
      :color="background"
    >
      <div>
        <v-icon v-if="status === 'success'" class="mr-2 message-icon">check_circle</v-icon> 
        <v-icon v-if="status === 'error'" class="mr-2 message-icon">warning</v-icon> 
        {{ text }}
      </div>
    </v-snackbar>
  </div>
</template>

<script>
import EventBus from '../main';
export default {
  data() {
    return {
      isActive: false,
      timeout: 4000,
      type: 'topline',
      text: '',
      background: '',
      status: '',
      timeoutId: null,
      unsubscribe: null
    }
  },
  created() {
    EventBus.$on('notification', (data) => {
      if (this.isActive) {
        this.isActive = false
        clearTimeout(this.timeoutId)
      }
      this.type = data.type || 'topline'
      this.isActive = true;
      this.text = data.text;
      this.status = data.status
      if(data.status === 'success'){
        this.background = '#4baf50';
      } else if (data.status === 'error') {
        this.background = '#ff5252';
      }
    
      this.timeoutId = setTimeout(
        () => {
          this.isActive = false
        }, this.timeout
      )
    })
  },
  mounted () {
    this.unsubscribe = this.$store.subscribeAction(action => {
      if (action.type === 'vEmit' && action.payload.name === 'notification') {
        this.showNotification(action.payload.data)
      }
    })
  },
  beforeDestroy () {
    EventBus.$off('notification', () => {
    })
    this.unsubscribe()
  },
  methods: {
    showNotification(data) {
      if (this.isActive) {
        this.isActive = false
        clearTimeout(this.timeoutId)
      }
      this.type = data.type || 'topline'
      this.isActive = true;
      this.text = data.text;
      this.status = data.status
      if(data.status === 'success'){
        this.background = '#4baf50';
      } else if (data.status === 'error') {
        this.background = '#ff5252';
      }
    
      this.timeoutId = setTimeout(
        () => {
          this.isActive = false
        }, this.timeout
      )
    }
  }
}
</script>

<style scoped>
  .notification-message {
    color: #fff;
    position: fixed; 
    width: 100%; 
    z-index: 5; 
    transform: translateY(-100%); 
    transition: transform .4s ease;
  }
  .message-top-line {
    height: 4px; background: rgba(0, 0, 0, .1);
  }
  .message-text {
    font-size: 14px;
  }
  .message-icon {
    color: rgba(0, 0, 0, .3); font-size: 17px;
  }
  .active {
    transform: translateY(0%)!important;
  }
</style>

<style>
  .notification-message-wrap .v-snack__wrapper {
    max-width: inherit!important;
    min-width: inherit!important;
  }
</style>

